import digitLogo from "assets/images/digit.png";
import rel from "assets/images/chiIcon.png";
import icicil from "assets/images/iciciLombard.png";
import kotakLogo from "assets/images/kotakLogo.png";
import nivaLogo from "assets/images/nivaLogo.jpeg";
import bhartilogo from "assets/images/axalogo.png";
import tataAig from "assets/images/tataAig.png";
import healthiansLogo from "assets/images/healthians-logo.png";
import redcliffe from "assets/images/Redcliffe.png";
import xyz from "assets/images/xyz.png";
import universallogo from "assets/images/UniversalSompo.png";
import aditya from "assets/images/our-download-logo.png";

import acko from "assets/insurerLogo/acko.png";
import bajaj from "assets/insurerLogo/bajaj_alianz.png";
import pnb from "assets/insurerLogo/pnb.png";
import reliance from "assets/insurerLogo/reliance.png";
// import reliance_general from "assets/insurerLogo/reliance_general.svg";
import royal_sundaram from "assets/insurerLogo/royal_sundaram.png";
import sbi_general from "assets/insurerLogo/sbi_general.jpeg";
import sriram_life from "assets/insurerLogo/sriram_life_insurance.png";
import sriram_general from "assets/insurerLogo/Shriram_General_Insurance.jpg";
import lic from "assets/insurerLogo/Life_Insurance_Corporation_of_India_(logo).svg";
import max from "assets/insurerLogo/Max_Life_Insurance_logo.svg";
import hdfc_ergo from "assets/insurerLogo/HDFC-ERGO.png";
import iffco from "assets/insurerLogo/IFFCOTokioGeneralInsurance.png";
import keshma from "assets/insurerLogo/Kshema-Logo.png";
import liberty from "assets/insurerLogo/liberty.png";
import magma from "assets/insurerLogo/magma.png";
import national_insurance from "assets/insurerLogo/national_insurance.png";
import navi from "assets/insurerLogo/navi.png";
import raheja from "assets/insurerLogo/Raheja.png";
import new_india from "assets/insurerLogo/NIACL0.jpeg";
import unighter_india from "assets/insurerLogo/unighted_india.jpeg";
import zuno from "assets/insurerLogo/zuno.jpeg";
import manipal from "assets/insurerLogo/manipal.png";
import sahara from "assets/insurerLogo/sahara.png";
import oriental from "assets/insurerLogo/oriental-insurance.png";
import star_health from "assets/insurerLogo/star-health-logo.png";
import future_generali from "assets/insurerLogo/Future_Generali_India_Life_Insurance_logo.jpg";
import ageas from "assets/insurerLogo/ageas.png";
import canara_bank from "assets/insurerLogo/canara-life-insurance-logo-web.png";
import aegon from "assets/insurerLogo/aegon.png";
import prudential from "assets/insurerLogo/prudential.png";
import sud from "assets/insurerLogo/SUD-Life-Logo.png";
// import india_first from "assets/insurerLogo/IndiaFirst_Modular_Logo_2022.svg";
import etil from "assets/insurerLogo/ETLI_Logo.png";
import creditIns from "assets/insurerLogo/CreditIns.png";
import icici_prudential from "assets/images/ICICI-Prudential.png";
import national_health_insurance from "assets/insurerLogo/national-insurance-company-india-logo.png";

export const insurers = {
  "ACKO GENERAL INSURANCE LIMITED": {
    logo: acko,
  },
  "ACKO LIFE INSURANCE LIMITED": {
    logo: acko,
  },
  "BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LIMITED": {
    logo: bajaj,
  },
  "BAJAJ ALLIANZ LIFE INSURANCE COMPANY LIMITED": {
    logo: bajaj,
  },
  "PNB METLIFE INDIA INSURANCE COMPANY LIMITED": {
    logo: pnb,
  },
  "RELIANCE NIPPON LIFE INSURANCE COMPANY LIMITED": {
    logo: reliance,
  },
  "Reliance General Insurance Company Limited": {
    logo: reliance,
  },
  "ROYAL SUNDARAM GENERAL INSURANCE COMPANY LIMITED": {
    logo: royal_sundaram,
  },
  "SBI GENERAL INSURANCE COMPANY LIMITED": {
    logo: sbi_general,
  },
  "SHRIRAM GENERAL INSURANCE COMPANY LIMITED": {
    logo: sriram_general,
  },
  "SHRIRAM LIFE INSURANCE COMPANY LIMITED": {
    logo: sriram_life,
  },
  "LIFE INSURANCE CORPORATION OF INDIA": {
    logo: lic,
  },
  "MAX LIFE INSURANCE COMPANY LIMITED": {
    logo: max,
  },
  "EXIDE LIFE INSURANCE COMPANY HAS MERGED WITH HDFC LIFE INSURANCE": {
    logo: hdfc_ergo,
  },
  "HDFC ERGO GENERAL INSURANCE COMPANY LIMITED": {
    logo: hdfc_ergo,
  },
  "IFFCO TOKIO General Insurance Company Limited": {
    logo: iffco,
  },
  "IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED": {
    logo: iffco,
  },
  "KSHEMA GENERAL INSURANCE LIMITED": {
    logo: keshma,
  },
  "LIBERTY GENERAL INSURANCE LIMITED": {
    logo: liberty,
  },
  "MAGMA HDI GENERAL INSURANCE COMPANY LIMITED": {
    logo: magma,
  },
  "NATIONAL INSURANCE COMPANY LIMITED": {
    logo: national_health_insurance,
  },
  "NAVI GENERAL INSURANCE LIMITED": {
    logo: navi,
  },
  "RAHEJA QBE GENERAL INSURANCE CO. LTD.": {
    logo: raheja,
  },
  "TATA AIG GENERAL INSURANCE COMPANY LIMITED": {
    logo: tataAig,
  },
  "THE NEW INDIA ASSURANCE COMPANY LIMITED": {
    logo: new_india,
  },
  "UNITED INDIA INSURANCE COMPANY LIMITED": {
    logo: unighter_india,
  },
  "ZUNO GENERAL INSURANCE LTD. (FORMERLY KNOWN AS EDELWEISS GENERAL INSURANCE COMPANY LIMITED)":
    {
      logo: zuno,
    },
  "ADITYA BIRLA HEALTH INSURANCE CO. LTD.": {
    logo: aditya,
  },
  "MANIPAL CIGNA HEALTH INSURANCE COMPANY LIMITED": {
    logo: manipal,
  },
  "SAHARA INDIA LIFE INSURANCE COMPANY LIMITED": {
    logo: sahara,
  },
  "UNIVERSAL SOMPO GENERAL INSURANCE COMPANY LIMITED": {
    logo: universallogo,
  },
  "ICICI LOMBARD GENERAL INSURANCE COMPANY LIMITED": {
    logo: icicil,
  },
  "GO DIGIT GENERAL INSURANCE LIMITED": {
    logo: digitLogo,
  },
  "ADITYA BIRLA HEALTH INSURANCE": {
    logo: aditya,
  },
  ORIENTAL: {
    logo: oriental,
  },
  "STAR HEALTH": {
    logo: star_health,
  },
  "HDFC LIFE INSURANCE COMPANY LIMITED": {
    logo: hdfc_ergo,
  },
  "ICICI PRUDENTIAL LIFE INSURANCE COMPANY LIMITED": {
    logo: icici_prudential,
  },
  "KOTAK MAHINDRA LIFE INSURANCE COMPANY LIMITED": {
    logo: kotakLogo,
  },
  "ADITYA BIRLA SUNLIFE INSURANCE COMPANY LIMITED": {
    logo: aditya,
  },
  "TATA AIA LIFE INSURANCE COMPANY LIMITED": {
    logo: tataAig,
  },
  "KOTAK MAHINDRA LIFE INSURANCE COMPANY LIMITED": {
    logo: kotakLogo,
  },
  "ADITYA BIRLA SUNLIFE INSURANCE COMPANY LIMITED": {
    logo: aditya,
  },
  "TATA AIA LIFE INSURANCE COMPANY LIMITED": {
    logo: tataAig,
  },
  "SBI LIFE INSURANCE COMPANY LIMITED": {
    logo: sbi_general,
  },
  "BHARTI AXA LIFE INSURANCE COMPANY LIMITED": {
    logo: bhartilogo,
  },
  "GO DIGIT LIFE INSURANCE LIMITED.": {
    logo: digitLogo,
  },
  "FUTURE GENERALI INDIA LIFE INSURANCE COMPANY LIMITED": {
    logo: future_generali,
  },
  "AGEAS FEDERAL LIFE INSURANCE COMPANY LIMITED": {
    logo: ageas,
  },
  "CANARA HSBC LIFE INSURANCE COMPANY LIMITED": {
    logo: canara_bank,
  },
  "AEGON LIFE INSURANCE COMPANY LIMITED": {
    logo: aegon,
  },
  "PRAMERICA LIFE INSURANCE COMPANY LIMITED": {
    logo: prudential,
  },
  "UNION DAI-ICHI LIFE INSURANCE COMPANY LIMITED": {
    logo: sud,
  },
  // "INDIAFIRST LIFE INSURANCE COMPANY LIMITED": {
  //   logo: india_first,
  // },
  "EDELWEISS TOKIO LIFE INSURANCE COMPANY LIMITED": {
    logo: etil,
  },
  "CREDIT ACCESS LIFE INSURANCE LIMITED": {
    logo: creditIns,
  },
  "ACKO LIFE INSURANCE LIMITED": {
    logo: acko,
  },
  "GO DIGIT LIFE INSURANCE LIMITED.": {
    logo: digitLogo,
  },
  "EXIDE LIFE INSURANCE COMPANY HAS MERGED WITH HDFC LIFE INSURANCE": {
    logo: hdfc_ergo,
  },

  "ICICI LOMBARD": {
    logo: icicil,
  },
  "BHARTI AXA": {
    logo: bhartilogo,
  },
  "RELIGARE-GHI": {
    logo: rel,
  },
  "RELIGARE-GPA": {
    logo: rel,
  },
  RELIGARE: {
    logo: rel,
  },
  KOTAK: {
    logo: kotakLogo,
  },
  "NIVA BUPA": {
    logo: nivaLogo,
  },
  GO_DIGIT: {
    logo: digitLogo,
  },
  TATA_AIG: {
    logo: tataAig,
  },
  HEALTHIANS: {
    logo: healthiansLogo,
  },
  REDCLIFFE: {
    logo: redcliffe,
  },
  XYZ: {
    logo: xyz,
  },
  UNIVERSAL_SOMPO: {
    logo: universallogo,
  },
  "ADITYA BIRLA HEALTH INSURANCE": {
    logo: aditya,
  },
};

export const FileFormat = {
  PolicyNumber:
    "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/Upload+Endorsement.xlsx",
};

export const planName = {
  gmc: "Group Health Insurance",
  gmc_m: "Group Health Insurance",
  gpa: "Group Personal Accident",
  gtl: "Group Term Life",
  GMC_M: "Group Health Insurance",
  GMC: "Group Health Insurance",
  GPA: "Group Personal Accident",
  GTL: "Group Term Life",
};

export const headers = [
  { label: "Name", key: "name" },
  { label: "Gender", key: "gender" },
  { label: "Date of Birth", key: "dob" },
  { label: "Email", key: "email" },
  { label: "Mobile", key: "employee_phone_number" },
  { label: "Dependents", key: "no_of_dependents" },
  { label: "Sum Insured", key: "sum_insured" },
  { label: "Subscription Amount", key: "total_amount" },
  { label: "Status", key: "policy_status" },
  { label: "Date of Addtion", key: "date_of_addition" },
  { label: "Policy No.", key: "policy_number" },
  { label: "Dependent Type", key: "dependents" },
  { label: "Dependent First Name", key: "first_name" },
  { label: "Dependent Last Name", key: "last_name" },
  { label: "Dependent DOB", key: "dependent_dob" },
];

export const Pdf = {
  SBO: "https://vitalimages.s3.ap-south-1.amazonaws.com/policyDocuments/PolicyTermsGroupCare.pdf",
  SBOM: "https://vitalimages.s3.ap-south-1.amazonaws.com/policyDocuments/PolicyTermsGroupCareMaternity.pdf",
  RETAIL:
    "https://vitalimages.s3.ap-south-1.amazonaws.com/policyDocuments/comprehensive.pdf",
  "KOTAK ESC M":
    "https://vitalimages.s3.ap-south-1.amazonaws.com/policyDocuments/VITAL_Kotak_Group_Care_Policy+Document_with_Maternity.pdf",
  "KOTAK ESC":
    "https://vitalimages.s3.ap-south-1.amazonaws.com/policyDocuments/VITAL_Kotak_Group_Care_Policy+Document_without_Maternity.pdf",
  "KOTAK PARENTAL":
    "https://vitalimages.s3.ap-south-1.amazonaws.com/Marketing/policy/Group+Care+Policy+Document_Kotak_Without_Maternity.pdf",
  "KOTAK UNLIMITED":
    "https://vitalimages.s3.ap-south-1.amazonaws.com/Marketing/policy/Group+Care+Policy+Document_Kotak_Without_Maternity+-+no+capping.pdf",
  "KOTAK UNLIMITED M":
    "https://vitalimages.s3.ap-south-1.amazonaws.com/Marketing/policy/Group+Care+Policy+Document_Kotak_With_Maternity_no+capping.pdf",
};

export const ArrayForFilter = [
  { name: "None", id: 0 },
  { name: "Activated", id: 1 },
  { name: "Activation Pending", id: 2 },
  { name: "Stopped", id: 3 },
];

export const historyHeaders = [
  { label: "Employee First Name", key: "employee_first_name" },
  { label: "Employee Last Name", key: "employee_last_name" },
  { label: "Gender", key: "gender" },
  { label: "Employee DOB", key: "employee_dob" },
  { label: "Mobile", key: "phone" },
  { label: "Email", key: "email" },
  { label: "Dependent Type", key: "relationship" },
  { label: "Dependent First Name", key: "first_name" },
  { label: "Dependent Last Name", key: "last_name" },
  { label: "Dependent DOB", key: "dob" },
  { label: "Sum Insured", key: "sum_insured" },
  { label: "Deductible", key: "deductible" },
];
